module.exports = __webpack_public_path__ + "bdec366eb6cf9cc5301de28dd23ab574.glb";